import { Component, OnInit } from "@angular/core";
import { FormField } from "../../../interfaces/form-field.model";
import { faPrint, faEraser } from "@fortawesome/free-solid-svg-icons";
import { formatDate } from "@angular/common";
import { NotifierService } from "angular-notifier";
import { AccessoryReportService } from "src/app/services/autopac-reports/accessory-report.service";

@Component({
  selector: "accessory-report",
  templateUrl: "./accessory-report.component.html",
  styleUrls: ["./accessory-report.component.css"],
})
export class AccessoryReportComponent implements OnInit {
  faPrint = faPrint;
  faEraser = faEraser;

  lockBtn = true;

  form!: FormField[];

  constructor(
    private notifier: NotifierService,
    private AccessoryReportService: AccessoryReportService,
  ) {}

  updateFields(event: any): void {
    this.form = event.fields;
    if (
      this.getFieldValue("FromDate") &&
      this.getFieldValue("ToDate")
    ) {
      this.lockBtn = false;
    } else {
      this.lockBtn = true;
    }
  }

  ngOnInit() {
    this.setUpFormFields();
  }

  private setUpFormFields(): void {
    this.form = [
      {
        type: "radio",
        id: "type",
        label: "Report Type",
        options: [
          {
            display: "Buyer",
            value: "Buyer",
          },
          {
            display: "Sales Consultant",
            value: "SalesConsultant",
          },
        ],
        value: "Buyer",
        required: true,
      },
      {
        type: "date",
        id: "FromDate",
        label: "From Date (dd/mm/yyyy)",
        required: true,
      },
      {
        type: "date",
        id: "ToDate",
        label: "To Date (dd/mm/yyyy)",
        required: true,
      },
      {
        type: "select",
        id: "Format",
        label: "Select Format",
        options: [
          {
            value: "pdf",
            display: "PDF",
          },
          {
            value: "excel",
            display: "EXCEL",
          },
          {
            value: "both",
            display: "BOTH",
          },
        ],
        value: "pdf",
      },
    ];
  }

  printStatus(): void {
    const searchData = this.populateSearchBody();
    this.AccessoryReportService.AccessoryReport(searchData).subscribe(
      {
        next: (response) => {
          if (this.getFieldValue("Format") == "pdf") {
            window.open(response.body.Name, "_blank");
          } else if (this.getFieldValue("Format") == "excel") {
            window.open(response.body.Value, "_blank");
          } else if (this.getFieldValue("Format") == "both") {
            window.open(response.body.Value, "_blank");
            window.open(response.body.Name, "_blank");
          }
        },
        error: (error) => {
          console.log(error);
          this.handleError("Error getting data", error);
        },
      },
    );
  }

  private populateSearchBody(): any {
    return {
      FromDate: formatDate(
        this.getFieldValue("FromDate"),
        "dd/MM/yyyy",
        "en-US",
      ),
      ToDate: formatDate(
        this.getFieldValue("ToDate"),
        "dd/MM/yyyy",
        "en-US",
      ),
      Type: this.getFieldValue("type"),
    };
  }

  private getFieldValue(id: string, index?: number): any {
    const field = this.form.find((f) => f.id === id);
    return index !== undefined ? field?.value[index] : field?.value;
  }

  private handleError(message: string, error: any): void {
    console.error(message, error);
    this.notifier.notify("error", message);
  }

  clear() {
    this.form.find((f) => f.id === "ToDate")!.value = "";
    this.form.find((f) => f.id === "FromDate")!.value = "";
    this.lockBtn = true;
  }
}
